import { Collection } from "@src/types/CollectionListResponse";
import { Diamond } from "@src/types/DiamondDetail";
import { User } from "@src/types/user";
import { MediaList } from "@src/types/mediaItem";
import { ShareVia } from "./utils/utils";

export type ShareProps = {
  mItem?: Diamond;
  onClose: any;
  shareType?: any;
  bulkItems?: Array<Diamond>;
  collection?: Collection;
  favoriteIds?: any;
  favoriteCount?: number;
  selectedOption: ShareVia | null;
  fromReviewPage?: boolean;
  stoneItemDetail?: Diamond;
  matchingPairItemDetail?: Diamond;
  jcSelectedOption?: any;
  personalization?: any;
};

export type ShareScreenProps = {
  isOpen: boolean;
  onClose: () => void;
  item?: Diamond;
  shareType?: any;
  bulkItems?: Array<Diamond>;
  collection?: Collection;
  favoriteIds?: any;
  favoriteCount?: number;
  selectedOption: ShareVia | null;
  fromReviewPage?: boolean;
  stoneItemDetail?: Diamond;
  matchingPairItemDetail?: Diamond;
  jcSelectedOption?: any;
  personalization?: any;
  title?: string;
  inWindow?: boolean;
};

export type CheckedItemsType = {
  [key: string]: boolean;
  [key: number]: boolean;
};

export type CheckedReportsType = {
  [key: string]: boolean;
  [key: number]: boolean;
};

export type LocalUriItem = {
  uri: string;
  content: string;
  order: string | number;
  extension: string;
};

export enum ShareType {
  singleShare,
  multiShare,
  favorites,
  collections,
}

export enum PairShareOption {
  PAIR = "PAIR",
  STONE_1 = "STONE_1",
  STONE_2 = "STONE_2",
}

export const EXPORTED_TYPES = {
  jpg: "image/jpeg",
  JPG: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  svg: "image/svg+xml",
  gif: "image/gif",
  webp: "image/webp",
  mp4: "application/mp4",
  pdf: "application/pdf",
  Pdf: "application/pdf",
};

export type ShareCheckBoxSectionProps = {
  shareType: ShareType;
  userInfo: User;
  priceChecked: boolean;
  setPriceChecked: (value: boolean) => void;
  imageItems: MediaList[];
  videoItems: MediaList[];
  reports: MediaList[];
  checkedItems: any;
  checkedReports: any;
  isVideoChecked: boolean;
  setIsVideoChecked: (value: boolean) => void;
  setCheckedItems: (value: any) => void;
  setBulkShareChecked?: any;
  bulkShareChecked?: any;
  itemDetail?: Diamond;
};

export type ShareOptionsProps = {
  selectedOption: string;
  control: any;
};

export type ShareShortTitleProps = {
  shareType: ShareType;
  userInfo: User;
  mItem?: Diamond;
  collection?: Collection;
  favoriteCount?: number;
  itemCount?: number;
  totalSalesPrice?: number;
};
